module.exports = "https://cdn.realtymogul.com/static/media/img_location_ny.0d80743e.jpg";